const routes = [
    {
        path: "/adjunct/payments",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "adjunctpayment_index",
        },
    },
];

export default routes;
